export default "__VITE_ASSET__38af9fc5__"